<template>
  <router-view />
</template>
<script>
  export default {
    name: 'GestorModule',
  }
</script>
